<template>
    <ModalDialog
        id="delete-modal"
        ref="modal"
        size="sm"
        :isLoading="isLoading"
        @submit="deleteTag"
        @closed="$emit('closed')"
    >
        <template #header>
            <div>
                {{ $t('delete') }} <b>{{ tag.name }}?</b>
            </div>
        </template>

        <template #default>
            <Alerts style="margin: 20px 15px" />
        </template>

        <template #footer="{ close, submit }">
            <button
                class="btn btn-sm btn-default"
                type="button"
                data-dismiss="modal"
                :disabled="isLoading"
                @click="close"
            >
                {{ $t('close') }}
            </button>

            <button
                class="btn btn-sm btn-danger"
                :disabled="isLoading"
                @click="submit"
            >
                <i
                    v-if="isLoading"
                    class="fa fa-refresh fa-spin"
                />
                <span>{{ $t('delete') }}</span>
            </button>
        </template>
    </ModalDialog>
</template>

<script>
import EventBus from '@/event-bus';
import ModalDialog from '@/components/modals/ModalDialog';

export default {
    components: {
        ModalDialog,
    },
    props: {
        tag: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
        };
    },
    watch: {
        tag() {
            EventBus.$emit('alertOptions', {
                displayAlert: false,
            });
        },
    },
    methods: {
        async deleteTag() {
            try {
                this.isLoading = true;
                this.$emit('loading', this.isLoading);

                const {
                    data: { name },
                } = await axios.delete(`/apis/tags/data/${this.tag.id}`, {
                    params: {
                        id: this.tag.id,
                    },
                });

                this.$refs.modal.close();

                await this.$emit('deleted', name);

                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: this.$t('messages.api.tag.deleted', { name }),
                });
            } catch (error) {
                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.isLoading = false;
                this.$emit('loading', this.isLoading);
            }
        },
    },
};
</script>
